import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DateStyled = styled.p`
  ${typography.bold[18]};
  color: ${colors.green[600]};
  margin: 0 0 7.4rem;
  text-align: center;
`;
